module.exports = __webpack_public_path__ + "static/media/p1.09d6c440.png";